import React, { useState, useCallback, useEffect } from "react";
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import CookieSettingPopup from "../../components/popup/CookieSettingPopup";
import TopLogo from '../../components/layout/TopLogo';
import TopBanner from '../../components/layout/TopBanner';
import coupon1 from '../../assets/images/coupon1.png';
import InfiniteScroll from 'react-infinite-scroller';
import coupon2 from '../../assets/images/coupon2.png';
import SecondaryButtonSmall from "../../components/button/SecondaryButtonSmall";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import helper from "../../functions/helper";
import { SearchShopCoupon } from "../../services/Coupon";
import { useDispatch, useSelector } from 'react-redux';
import { setShop } from "../../features/ShopSlice";
import qrScan from '../../assets/images/icon/qr-scan.svg';
import TopBtnShop from "../../components/layout/TopBtnShop";
import CustomSwitch from "../../components/button/CustomSwitch";
import { SearchEmployee } from "../../services/Shop";
import useWindowDimensions from "../../functions/getScreen";

export default function ShopCouponMain() {

  const store = useSelector((state) => state.shop)
  const dispatch = useDispatch();
  const [activeCouponList, setActiveCouponList] = React.useState([]);
  const [pendingCouponList, setPendingCouponList] = React.useState([]);
  const [expireCouponList, setExpireCouponList] = React.useState([]);

  const [openCookiePopup, setOpenCookiePopup] = React.useState(false);

  const navigate = useNavigate();
  const [isActiveCouponActive, setIsActiveCouponActive] = React.useState(true);
  const [isPendingCouponActive, setIsPendingCouponActive] = React.useState(false);
  const [isExpireCouponActive, setIsExpireCouponActive] = React.useState(false);
  const [shopId, setShopId] = React.useState(null);

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const { height } = useWindowDimensions();

  const initialLoadMore = {
    limit: 2,
    offset: 0,
  }

  const [loadMore, setLoadmore] = React.useState(initialLoadMore);
  const [loadMorePending, setLoadMorePending] = React.useState(initialLoadMore);
  const [loadMoreExpire, setLoadMoreExpire] = React.useState(initialLoadMore);
  const [nextPage, setNextPage] = useState(false)
  const [fetching, setFetching] = useState(false);
  const [isDataNotFound, setIsDataNotFound] = React.useState(false);
  const [isChangeTab, setIsChangeTab] = React.useState(false)


  React.useEffect(() => {
    getSearchEmployee()
  }, []);

  React.useEffect(() => {
    if (shopId) {
      getSearchShopCoupon(1)
    }
  }, [shopId]);

  async function getSearchEmployee() {
    return await SearchEmployee({ lineId })
      .then(async (response) => {
        if (+response.data.resultCode !== 20000) {
          navigate("/register");
        } else {
          setShopId(response.data.body.shopId)
          fnSetData('shopId', response.data.body.shopId)
          fnSetData('shopName', response.data.body.shopName)
          if (response.data.body.isOwner) {
            fnSetData('isOwner', true)
            fnSetData('ownerId', response.data.body.employeeId)
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getSearchShopCoupon(status) {
    let limit, offset
    if (status === 1) {
      limit = loadMore.limit
      offset = loadMore.offset
    } else if (status === 2) {
      limit = loadMorePending.limit
      offset = loadMorePending.offset
    } else if (status === 3) {
      limit = loadMoreExpire.limit
      offset = loadMoreExpire.offset
    }

    return await SearchShopCoupon({ data: { shopId: shopId, status: status, limit: limit, offset: offset } })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          let data = response.data.body
          let tmp = null
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            element.widthBlue = element.usedAmount / element.amount * 100
            element.widthGray = ((element.amount - element.usedAmount) / element.amount * 100) + 1
            if (element.discountType === 'Fix') {
              element.discountText = `฿${helper.numberWithCommas(element.discount)} | ขั้นต่ำ ฿${helper.numberWithCommas(element.min)}`
            } else {
              element.discountText = `${helper.numberWithCommas(element.discount)}% | ขั้นต่ำ ฿${helper.numberWithCommas(element.min)}`
            }
          }
          if (status === 1) {
            tmp = [...activeCouponList, ...data]
            if (tmp.length < response.data.totalRows) {
              let tmp2 = { ...loadMore }
              tmp2.offset = tmp2.offset + tmp2.limit
              tmp2.limit = 2
              setLoadmore(tmp2)
              setNextPage(true)
            } else {
              setNextPage(false)
            }
            setActiveCouponList(tmp)
          } else if (status === 2) {
            tmp = [...pendingCouponList, ...data]
            if (tmp.length < response.data.totalRows) {
              let tmp2 = { ...loadMorePending }
              tmp2.offset = tmp2.offset + tmp2.limit
              tmp2.limit = 2
              setLoadMorePending(tmp2)
              setNextPage(true)
            } else {
              setNextPage(false)
            }
            setPendingCouponList(tmp)
          } else if (status === 3) {
            tmp = [...expireCouponList, ...data]
            if (tmp.length < response.data.totalRows) {
              let tmp2 = { ...loadMoreExpire }
              tmp2.offset = tmp2.offset + tmp2.limit
              tmp2.limit = 2
              setLoadMoreExpire(tmp2)
              setNextPage(true)
            } else {
              setNextPage(false)
            }
            setExpireCouponList(tmp)
          }

          setIsChangeTab(false)
        } else {
          setActiveCouponList([])
          setNextPage(false)
          setIsDataNotFound(true)
          setIsChangeTab(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setShop(tmpObj));
  }

  const fetchItems = useCallback(
    async () => {
      if (fetching) {
        return;
      }
      setFetching(true);
      try {
        if (nextPage) {
          await getSearchShopCoupon(1);
        }

      } finally {
        setFetching(false);
      }
    },
    [fetching, nextPage]
  );

  const fetchItems2 = useCallback(
    async () => {
      if (fetching) {
        return;
      }
      setFetching(true);

      try {
        if (nextPage) {
          await getSearchShopCoupon(2);
        }

      } finally {
        setFetching(false);
      }
    },
    [fetching, nextPage]
  );

  const fetchItems3 = useCallback(
    async () => {
      if (fetching) {
        return;
      }
      setFetching(true);

      try {
        if (nextPage) {
          await getSearchShopCoupon(3);
        }

      } finally {
        setFetching(false);
      }
    },
    [fetching, nextPage]
  );

  const hasMoreItems = !!nextPage;

  const loader = (
    <div key="loader" className="loader text-center text-[20px] text-blueGray2">
      Loading ...
    </div>
  );

  useEffect(() => {
    if (isChangeTab) {
      setLoadmore(initialLoadMore)
      setLoadMorePending(initialLoadMore)
      setLoadMoreExpire(initialLoadMore)
      setNextPage(true)
      setIsDataNotFound(false)
      setActiveCouponList([])
      setPendingCouponList([])
      setExpireCouponList([])
    }
  }, [isChangeTab]);


  return (
    <div id="shop-page">
      <TopLogo />
      <TopBanner type="memberPrivilage" />
      <CookieSettingPopup
        open={openCookiePopup}
        onClose={() => {
          setOpenCookiePopup(false);
        }}
      />
      {/*<img src={ShopBanner} alt="shopbanner" className="w-full" />*/}
      <div id="shop" style={{
        // backgroundImage: `url(${background})`,
        minHeight: "80px",
      }}
        className="bg-white px-[20px] mt-[-40px]">
        <TopBtnShop type="coupon" isOwner={store['isOwner']} />

        {/* <div className="grid grid-cols-2 px-[20px]">
                    <div style={{ borderRight: "2px #0A4197 solid" }}>
                        <img className="bg" style={{ margin: "auto" }} src={myCouponBtn} alt="Snow" />
                        <div className="blue-line w-[74px] mt-[5px]" style={{ marginInline: "auto" }} ></div>
                    </div>
                    <img className="bg" style={{ margin: "auto" }} src={rewardBtn} alt="Snow" />
                </div> */}

      </div>
      <div className="bg-lightBlue2" style={{
        height: `${height - 387}px`,
        padding: "20px 40px",
      }}>

        <div className="grid grid-cols-3 rounded-full h-[32px] bg-white">
          <div className={isActiveCouponActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
            <div className="w-fit mx-auto mt-[3%]">
              <button className={isActiveCouponActive ? "text-white" : "text-blue"}
                onClick={() => {
                  setIsActiveCouponActive(true)
                  setIsPendingCouponActive(false)
                  setIsExpireCouponActive(false)
                  setIsChangeTab(true)
                }}
              >กำลังใช้งาน</button>
            </div>
          </div>
          <div className={isPendingCouponActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
            <div className="w-fit mx-auto mt-[3%]">
              <button className={isPendingCouponActive ? "text-white" : "text-blue"}
                onClick={() => {
                  setIsActiveCouponActive(false)
                  setIsPendingCouponActive(true)
                  setIsExpireCouponActive(false)
                  setIsChangeTab(true)
                }}
              >เตรียมใช้งาน</button>
            </div>
          </div>
          <div className={isExpireCouponActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
            <div className="w-fit mx-auto mt-[3%]">
              <button className={isExpireCouponActive ? "text-white" : "text-blue"}
                onClick={() => {
                  setIsActiveCouponActive(false)
                  setIsPendingCouponActive(false)
                  setIsExpireCouponActive(true)
                  setIsChangeTab(true)
                }}
              >คูปองหมดอายุ</button>
            </div>
          </div>
        </div >

        {isActiveCouponActive && !isDataNotFound &&
          <div
            className="overflow-y-auto mt-[20px]"
            style={{
              height: `${height - 523}px`,
            }}
          >
            <InfiniteScroll
              pageStart={0}
              loadMore={fetchItems}
              hasMore={hasMoreItems}
              loader={loader}
              useWindow={false}
            >
              {activeCouponList.map((item, index) => (
                <div key={index}>
                  <div className="flex h-[137px] w-full mb-[20px]">
                    <div style={{ borderRight: "2px dashed #E8E8E8", width: "30%" }} className="relative bg-white coupon-shop">
                      <div className="h-[35px] mt-[10px]">
                        {/* <CustomSwitch
                          defaultChecked
                          checked={item.status === 'Active'}
                        /> */}
                        {+item.usedAmount === +item.amount ?
                          <div className="w-[59px] h-[20px] pt-[1px] mx-auto" style={{ borderRadius: '28px', border: '1px solid #6D6E71' }}>
                            <p className="text-darkGray text-[12px] w-fit mx-auto">เก็บครบแล้ว</p>
                          </div>
                          :
                          <>
                            {item.status === 'Active' ?
                              <div className="w-[59px] h-[20px] pt-[2px] mx-auto bg-lightBlue" style={{ borderRadius: '28px' }}>
                                <p className="text-white text-[12px] w-fit mx-auto">เปิดใช้งานอยู่</p>
                              </div>
                              :
                              <div className="w-[59px] h-[20px] pt-[1px] mx-auto" style={{ borderRadius: '28px', border: '1px solid #6D6E71' }}>
                                <p className="text-darkGray text-[12px] w-fit mx-auto">ปิดใช้งานอยู่</p>
                              </div>
                            }
                          </>
                        }

                      </div>
                      <div className="h-[80px] relative">
                        {item.picture ? (
                          <img style={{
                            width: "80%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                          }} src={item.picture} alt="" />
                        ) : (
                          <img style={{
                            width: "80%",
                            position: "absolute",
                            top: "40%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                          }} src={coupon2} alt="" />
                        )}
                      </div>
                    </div>
                    <div className="bg-white" style={{ borderRadius: "8px", width: "70%" }}>
                      <div className="px-[15px] py-[7px]">
                        <div>
                          <div className="flex ml-auto mr-[0px] w-fit">
                            <p className="text-lightBlue text-[12px]">{item.usedAmount}</p><p className="text-gray text-[12px]">/{item.amount}</p>
                          </div>
                          <div className="flex">
                            <div className="gradient-line h-[6px]" style={{ width: `${item.widthBlue}%`, zIndex: "999" }}></div>
                            <div className="gray-line2 ml-[-2px] h-[6px]" style={{ width: `${item.widthGray}%` }}> </div>
                          </div>
                          <div className="flex">
                            <LocationOnIcon sx={{
                              color: "#00B9F1",
                              width: "13px",
                              marginTop: "-2px"
                            }} />
                            <p className="w-[170px] text-lightBlue text-[12px] mt-[3px]">{item.shopName}</p>
                          </div>
                          <p className="text-blue text-[14px] leading-[12px]">{item.name}</p>
                          <p className="text-gray text-[14px] leading-[16px]" >ส่วนลด {item.discountText}</p>
                          <p className="text-[12px] leading-[14px]">วันที่เริ่มต้นใช้คูปอง {dayjs(item.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {dayjs(item.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                          <SecondaryButtonSmall
                            style={{ float: "right" }}
                            className="w-fit small-btn" onClick={() => {
                              fnSetData('couponId', item.id)
                              fnSetData('owner', item.owner)
                              navigate('/shop-coupon-detail')
                            }}
                            variant="outlined">ดูรายละเอียด
                          </SecondaryButtonSmall>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              ))}
            </InfiniteScroll>
          </div>
        }

        {isActiveCouponActive && isDataNotFound &&
          <div className="mt-[50px]">
            <img className="mx-auto w-[200px] opacity-30" src={coupon1} alt="Snow" />
            <div className="mt-[30px] text-center">
              <p className="mx-auto text-[14px] text-white">
                ยังไม่มีคูปองที่กำลังใช้งาน
              </p>
            </div>
            <div className="mb-[50px] text-center">
              <p className="mx-auto text-[14px] text-white">
                คุณสามารถสร้างคูปองสำหรับร้านคุณได้
              </p>
            </div>
          </div>
        }

        {isPendingCouponActive && !isDataNotFound &&
          <div
            className="overflow-y-auto mt-[20px]"
            style={{
              height: `${height - 523}px`,
            }}>
            <InfiniteScroll
              pageStart={0}
              loadMore={fetchItems2}
              hasMore={hasMoreItems}
              loader={loader}
              useWindow={false}
            >
              {pendingCouponList.map((item, index) => (
                <div key={index}>
                  <div className="flex h-[137px] w-full mb-[20px]">
                    <div style={{ borderRight: "2px dashed #E8E8E8", width: "30%" }} className="relative bg-white coupon-shop">
                      <div className="h-[35px] mt-[10px]">
                        {/* <CustomSwitch
                                                defaultChecked
                                                checked={false}
                                            /> */}
                        {/* {item.status === 'Active' ?
                                                    <div className="w-[59px] h-[20px] pt-[2px] mx-auto bg-lightBlue" style={{ borderRadius: '28px' }}>
                                                        <p className="text-white text-[12px] w-fit mx-auto">เปิดใช้งานอยู่</p>
                                                    </div>
                                                    : */}
                        <div className="w-[59px] h-[20px] pt-[1px] mx-auto" style={{ borderRadius: '28px', border: '1px solid #6D6E71' }}>
                          <p className="text-darkGray text-[12px] w-fit mx-auto">ปิดใช้งานอยู่</p>
                        </div>
                        {/* } */}
                      </div>
                      <div className="h-[80px] relative">
                        {item.picture ? (
                          <img style={{
                            width: "80%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                          }} src={item.picture} alt="" />
                        ) : (
                          <img style={{
                            width: "80%",
                            position: "absolute",
                            top: "40%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                          }} src={coupon2} alt="" />
                        )}
                      </div>
                    </div>
                    <div className="bg-white w-[70%]" style={{ borderRadius: "8px" }}>
                      <div className="px-[15px] py-[7px]">
                        <div>
                          <div className="flex ml-auto mr-[0px] w-fit">
                            <p className="text-lightBlue text-[12px]">{item.usedAmount}</p><p className="text-gray text-[12px]">/{item.amount}</p>
                          </div>
                          <div className="flex">
                            <div className="gradient-line h-[6px]" style={{ width: `${item.widthBlue}%`, zIndex: "999" }}></div>
                            <div className="gray-line2 ml-[-2px] h-[6px]" style={{ width: `${item.widthGray}%` }}> </div>
                          </div>
                          <div className="flex">
                            <LocationOnIcon sx={{
                              color: "#00B9F1",
                              width: "13px",
                              marginTop: "-2px"
                            }} />
                            <p className="w-[170px] text-lightBlue">{item.shopName}</p>
                          </div>
                          <p className="text-blue text-[14px] leading-[12px]">{item.name}</p>
                          <p className="text-gray text-[14px] leading-[16px]" >ส่วนลด {item.discountText}</p>
                          <p className="text-[12px] leading-[14px]">วันที่เริ่มต้นใช้คูปอง {dayjs(item.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {dayjs(item.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                          <SecondaryButtonSmall
                            style={{ float: "right" }}
                            className="w-fit small-btn" onClick={() => {
                              fnSetData('couponId', item.id)
                              navigate('/shop-coupon-detail')
                            }}
                            variant="outlined">ดูรายละเอียด
                          </SecondaryButtonSmall>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              ))}
            </InfiniteScroll>
          </div>
        }

        {isPendingCouponActive && isDataNotFound &&
          <div className="mt-[50px]">
            <img className="mx-auto w-[200px] opacity-30" src={coupon1} alt="Snow" />
            <div className="mt-[30px] text-center">
              <p className="mx-auto text-[14px] text-white">
                ยังไม่มีคูปองที่เตรียมใช้งาน
              </p>
            </div>
            <div className="mb-[50px] text-center">
              <p className="mx-auto text-[14px] text-white">
                คุณสามารถสร้างคูปองสำหรับร้านคุณได้
              </p>
            </div>
          </div>
        }

        {isExpireCouponActive && !isDataNotFound &&
          <div
            className="overflow-y-auto mt-[20px]"
            style={{
              height: `${height - 523}px`,
            }}>
            <InfiniteScroll
              pageStart={0}
              loadMore={fetchItems3}
              hasMore={hasMoreItems}
              loader={loader}
              useWindow={false}
            >
              {expireCouponList.map((item, index) => (
                <div key={index}>
                  <div className="flex h-[137px] w-full mb-[20px]">
                    <div style={{ borderRight: "2px dashed #E8E8E8", width: "30%" }} className="relative bg-white coupon-shop">
                      <div className="h-[35px] mt-[10px]">
                        {/* <CustomSwitch
                                                defaultChecked
                                                checked={false}
                                            /> */}
                        <div className="w-[59px] h-[20px] pt-[1px] mx-auto" style={{ borderRadius: '28px', border: '1px solid #6D6E71' }}>
                          <p className="text-darkGray text-[12px] w-fit mx-auto">ปิดใช้งานอยู่</p>
                        </div>

                      </div>
                      <div className="h-[80px] relative">
                        <div
                          className="items-center absolute px-[8px] py-[10px] gradientBg-gray"
                        >
                          <p className="text-[20px] leading-[18px] font-bold text-white">
                            หมดอายุ
                          </p>
                        </div>
                        {item.picture ? (
                          <img style={{
                            width: "80%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                          }} src={item.picture} alt="" />
                        ) : (
                          <img style={{
                            width: "80%",
                            position: "absolute",
                            top: "40%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                          }} src={coupon2} alt="" />
                        )}
                      </div>
                    </div>
                    <div className="bg-white w-[70%]" style={{ borderRadius: "8px" }}>
                      <div className="px-[15px] py-[7px]">
                        <div>
                          <div className="flex ml-auto mr-[0px] w-fit">
                            <p className="text-lightBlue text-[12px]">{item.usedAmount}</p><p className="text-gray text-[12px]">/{item.amount}</p>
                          </div>
                          <div className="flex">
                            <div className="gradient-line" style={{ width: `${item.widthBlue}%`, zIndex: "999" }}></div><div className="gray-line2 ml-[-2px]" style={{ width: `${item.widthGray}%` }}> </div>
                          </div>
                          <div className="flex">
                            <LocationOnIcon sx={{
                              color: "#00B9F1",
                              width: "13px",
                              marginTop: "-2px"
                            }} />
                            <p className="w-[170px] text-lightBlue">{item.shopName}</p>
                          </div>
                          <p className="text-blue text-[14px] leading-[12px]">{item.name}</p>
                          <p className="text-gray text-[14px] leading-[16px]" >ส่วนลด {item.discountText}</p>
                          <p className="text-[12px] leading-[14px]">วันที่เริ่มต้นใช้คูปอง {dayjs(item.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {dayjs(item.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                          <SecondaryButtonSmall
                            style={{ float: "right" }}
                            className="w-fit small-btn" onClick={() => {
                              fnSetData('couponId', item.id)
                              navigate('/shop-coupon-detail')
                            }}
                            variant="outlined">ดูรายละเอียด
                          </SecondaryButtonSmall>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              ))}
            </InfiniteScroll>


          </div>
        }

        {isExpireCouponActive && isDataNotFound &&
          <div className="my-[50px]">
            <img className="mx-auto w-[200px] opacity-30" src={coupon1} alt="Snow" />
            <div className="mt-[30px] text-center">
              <p className="mx-auto text-[14px] text-white">
                ยังไม่มีคูปองหมดอายุ
              </p>
            </div>
          </div>
        }
      </div>

      <div className="bg-white py-[20px] px-[30px]">
        {/* <PrimaryButton variant="contained" className="w-full" onClick={() => navigate("/shop-add-coupon", { state: null })}>
          เพิ่มคูปองใหม่
        </PrimaryButton>
        <div className="mt-[10px]"> */}
          <SecondaryButton variant="outlined" className="w-full" onClick={() => navigate('/shop-scan-qr-code')}>
            <img className="w-[24px]" src={qrScan} alt="" />
            <p> สแกนคูปอง</p>
          </SecondaryButton>
        {/* </div> */}
      </div>
    </div >
  )
}